import { AwardingClient } from "@/utils/EvoClient";
import { OpenOffersDto } from "../dto";
import { AxiosResponse } from "axios";

const ENDPOINT = "c/open-offers";

export default async function openOffers(dto: OpenOffersDto): Promise<string> {
  return ((await AwardingClient.post(ENDPOINT, dto)) as AxiosResponse).data.id;
}
